import camelcase from 'camelcase';

import { channelPlatformNamesMap } from '../constants/channelsPlatforms.js';

export const getRowId = (row: { id: string }) => row.id || '0';

export const transformChannelPlatformName = (name: string) => {
  if (!name) {
    return '';
  }

  return (
    channelPlatformNamesMap[
      camelcase(name) as keyof typeof channelPlatformNamesMap
    ] || camelcase(name)
  );
};
